import { ID } from '@griply/types';
import { useUpdateUserSettings } from 'features/user';
import { useCallback } from 'react';
import { useStoredBoolean } from 'shared/hooks/use-stored-boolean';
import { useUser } from 'shared/hooks/use-user';

export type SetupChecklistState = {
  collapsed: boolean;
  dismissed: boolean;
  everComplete: boolean;
  setCollapsed: (value: boolean) => void;
  dismiss: () => void;
  markComplete: () => void;
};

const COLLAPSED_KEY_PREFIX = 'griply.setup-checklist-collapsed.';

// Collapse is per-browser (localStorage); dismissed + everComplete live in the user profile (cross-device).
export const useSetupChecklistState = (
  uid: ID | undefined,
): SetupChecklistState => {
  const user = useUser();
  const updateUserSettings = useUpdateUserSettings();

  const [collapsed, setCollapsed] = useStoredBoolean(
    `${COLLAPSED_KEY_PREFIX}${uid ?? ''}`,
  );

  const dismiss = useCallback(
    () => updateUserSettings({ setupChecklist: { dismissed: true } }),
    [updateUserSettings],
  );
  const markComplete = useCallback(
    () => updateUserSettings({ setupChecklist: { everComplete: true } }),
    [updateUserSettings],
  );

  return {
    collapsed,
    dismissed: !!user?.settings?.setupChecklist?.dismissed,
    everComplete: !!user?.settings?.setupChecklist?.everComplete,
    setCollapsed,
    dismiss,
    markComplete,
  };
};
